module.exports = __webpack_public_path__ + "img/03.f7aa55d1.png";